/// <reference path="../../public/jquery-1.6.2.min.js" />
/// <reference path="../../public/AJAX.js" />
/// <reference path="../../public/General.js" />
/// <reference path="../../public/Security.js" />
/// <reference path="../../public/ServiceURL.js" />
/// <reference path="../../SumoDataAccess.js" />
/// <reference path="../../SumoClass.js" />
/// <reference path="../ControlBase.js" />

if (isNullOrUndefined(sumo)) {
    throw ('Layer.js requies the sumo namespace defined in SumoClass.js');
}

if (isNullOrUndefined(sumo.maps)) {
    sumo.maps = {};
}

// --- LAYERS
//  layerAdd(aLayerName, aOptions: {
//    optional renderType = 'marker', 
//    optional doesPlayback = false,
//    optional isVisible = false,
//    optional isDraggable = false,
//    optional shapeChangeHandler = null, 
//    optional shapeCenterChangedHandler = null, 
//    optional dragEndEventHandler = null,
//    optional clickEventHandler = null,
//    optional zIndexStart = 0,
//    optional dataSource = null})
//      aRenderType:
//          'marker'
//          'geometry'
//          'linesegment'
//          'label'
//      aDoesPlayback: if true then the dataset will be played back point by point
//      aIsVisible: if true then the layer will be immediately rendered
//      aDataSource: the dataset that defines the points
//          'marker': dataItem: {latitude, longitude, iconUri, anchor[x,y], data, doHover, hoverHtml, hoverCssClass, hoverVerticalOffset, hoverHorizontalOffset}
//          'geometry': dataItem: {id, type: ('circle'|'polygonal'), centerLatitude, centerLongitude, radius (in meters), vertices: [Point:{latitude, longitude}], 
//                      hoverHtml, fillColor, fillOpacity, strokeColor, strokeOpacity, strokeWeight, data}
//          'linesegment': dataItem: { segments[latitude, longitude], hoverHtml, data} - sort order matters
//          'label': dataItem: {latitude, longitude, text, cssClass, data, verticalOffset, horizontalOffset} - sort order matters
//  layerRemove(aLayerName)
//  layerShow(aLayerName)
//  layerHide(aLayerName)
//  layerSetDataSource(aLayerName, aDataset)
//  layerSetRenderType(aLayerName, aRenderType)
//      aRenderType:
//          'marker'
//          'geometry'
//          'linesegment'
//          'Label'
//          'label'
//  layerdoesPlayback(aLayerName, aDoesPlayback)

sumo.maps.Layer = function (aName, aMap, aOptions) {
    "use strict";

    sumo.maps.Layer.prototype.baseClass.call(this);

    var mThis = this,
        mOverlays = [],
    //mSecondaryOverlays = [],
        mMap = aMap,
        mName = aName,
        mDoesPlayback = false,
        mIsVisible = false,
        mDataSource = null,
        mIsDirty = false,
        mClickEventHandler = null,
        mRightClickEventHandler = null,
        mHoverEventHandler = null, // patch 2.5.9 item
        mHoverOutEventHandler = null, // patch 2.5.9 item
        mMouseOverTimeOut = null, // patch 2.5.9 item
        mHoverMapDelaySeconds = 1, // patch 2.5.9 item
        mDragEndEventHandler = null,
        mShapeChangeHandler = null,
        mZIndexStart = 0,
        mMarkerImageSize = null,
        mLineSegmentColor = 'red',
    //cMaxZIndex = 214748364, //2147483647
        mRenderType = 'marker',
        mIdentityProperty = 'identity',
        mMarkerCollection = [],
        mVisitPointIndex = 1000;

    this.setRenderType = function (aRenderType) {
        var lRenderType = aRenderType.toLowerCase();
        switch (lRenderType) {
            case 'marker':
            case 'geometry':
            case 'linesegment':
            case 'label':
                break;
            default:
                throw ('valid render types include: marker, geometry, linesegment, and label.');
        }
        mRenderType = lRenderType;
    };

    this.doesPlayback = function (aValue) {
        if (!this.isNothing(aValue)) {
            switch (aValue) {
                case true:
                case false:
                    break;
                default: throw ('doesPlayback accepts aValue as boolean.');
            }
            mDoesPlayback = aValue;
        }
        return mDoesPlayback;
    };

    if (!this.isNothing(aOptions)) {
        if (!this.isNothing(aOptions.renderType)) {
            this.setRenderType(aOptions.renderType);
        }
        if (!this.isNothing(aOptions.doesPlayback)) {
            this.doesPlayback(aOptions.doesPlayback);
        }
        if (!this.isNothing(aOptions.isVisible)) {
            mIsVisible = aOptions.isVisible;
        }
        if (!this.isNothing(aOptions.clickEventHandler)) {
            mClickEventHandler = aOptions.clickEventHandler;
        }
        if (!this.isNothing(aOptions.rightClickEventHandler)) {
            mRightClickEventHandler = aOptions.rightClickEventHandler;
        }
        if (!this.isNothing(aOptions.zIndexStart)) {
            mZIndexStart = aOptions.zIndexStart;
        }
        if (!this.isNothing(aOptions.dragEndEventHandler)) {
            mDragEndEventHandler = aOptions.dragEndEventHandler;
        }
        if (!this.isNothing(aOptions.shapeChangeHandler)) {
            mShapeChangeHandler = aOptions.shapeChangeHandler;
        }
        if (!this.isNothing(aOptions.markerImageSize)) {
            mMarkerImageSize = aOptions.markerImageSize;
        }
        if (!this.isNothing(aOptions.lineSegmentColor)) {
            mLineSegmentColor = aOptions.lineSegmentColor;
        }
        if (!this.isNothing(aOptions.identityProperty)) {
            mIdentityProperty = aOptions.identityProperty;
        }
        if (!this.isNothing(aOptions.hoverEventHandler)) {
            mHoverEventHandler = aOptions.hoverEventHandler;
        }
        if (!this.isNothing(aOptions.hoverOutEventHandler)) {
            mHoverOutEventHandler = aOptions.hoverOutEventHandler;
        }

        // setDataSource must be called last
        if (!this.isNothing(aOptions.dataSource)) {
            this.setDataSource(aOptions.dataSource);
        }
    }

    this.name = function () {
        return mName;
    };

    this.map = function () {
        return mMap;
    };

    this.renderType = function () {
        return mRenderType;
    };

    this.dragEndHandler = function (aCallback) {
        var lResult = null;
        if (!mThis.isNothing(aCallback)) {
            mDragEndEventHandler = aCallback;
        } else {
            lResult = mDragEndEventHandler;
        }
        return mDragEndEventHandler;
    };

    function setVisibility(aValue) {
        var lIndex,
            lLength = mOverlays.length,
            lOverlay;
        for (lIndex = 0; lIndex < lLength; lIndex++) {
            lOverlay = mOverlays[lIndex];
            if (!mThis.isNothing(lOverlay)) {
                lOverlay.setVisible(aValue);
            }
        }
    }

    function clearOverlays() {
        var lIndex,
            lLength = mOverlays.length,
            lOverlay;

        for (lIndex = 0; lIndex < lLength; lIndex++) {
            lOverlay = mOverlays[lIndex];
            if (!mThis.isNothing(lOverlay)) {
                if (!mThis.isNothing(lOverlay.sumoOverlayOnClickListener)) {
                    google.maps.event.removeListener(lOverlay.sumoOverlayOnClickListener);
                }
                if (!mThis.isNothing(lOverlay.sumoOverlayOnRightClickListener)) {
                    google.maps.event.removeListener(lOverlay.sumoOverlayOnRightClickListener);
                }
                if (!mThis.isNothing(lOverlay.sumoCircleRadiusChanged)) {
                    google.maps.event.removeListener(lOverlay.sumoCircleRadiusChanged);
                }
                if (!mThis.isNothing(lOverlay.sumoCircleCenterChanged)) {
                    google.maps.event.removeListener(lOverlay.sumoCircleCenterChanged);
                }
                if (!mThis.isNothing(lOverlay.sumoPolygonOnInsert)) {
                    google.maps.event.removeListener(lOverlay.sumoPolygonOnInsert);
                }
                if (!mThis.isNothing(lOverlay.sumoPolygonOnRemove)) {
                    google.maps.event.removeListener(lOverlay.sumoPolygonOnRemove);
                }
                if (!mThis.isNothing(lOverlay.sumoPolygonOnSet)) {
                    google.maps.event.removeListener(lOverlay.sumoPolygonOnSet);
                }
                if (!mThis.isNothing(lOverlay.sumoOverlayOnDragEndListener)) {
                    google.maps.event.removeListener(lOverlay.sumoOverlayOnDragEndListener);
                }
                if (!mThis.isNothing(lOverlay.OverlayOnHoverListener)) {
                    google.maps.event.removeListener(lOverlay.OverlayOnHoverListener);
                }
                if (!mThis.isNothing(lOverlay.OverlayOnHoverOutListener)) {
                    google.maps.event.removeListener(lOverlay.OverlayOnHoverOutListener);
                }
                if (!mThis.isNothing(lOverlay.hoverLabel)) {
                    google.maps.event.removeListener(lOverlay.sumoOverlayOnMouseEnter);
                    google.maps.event.removeListener(lOverlay.sumoOverlayOnMouseExit);
                    lOverlay.hoverLabel.setMap(null);
                    lOverlay.hoverLabel = null;
                }
				lOverlay.setMap(null);
                mOverlays[lIndex] = null;
            }
        }
        mOverlays.length = 0;
    }

    function overlay_OnClick(aEvent) {
        var lOverlay = this;
        if (!mThis.isNothing(mClickEventHandler)) {
            mClickEventHandler(lOverlay, aEvent);
        }
    }
    function overlay_OnRightClick(aEvent) {
        var lOverlay = this;
        aEvent['position'] = window.event;
        setTimeout(function(){
            if (!mThis.isNothing(mRightClickEventHandler)) {
                mRightClickEventHandler(lOverlay, aEvent,'rightclick');
            }
        }, 0, aEvent);
    }

    function overlay_OnDragEnd(aEvent) {
        var lOverlay = this;
        if (!mThis.isNothing(mDragEndEventHandler)) {
            mDragEndEventHandler(lOverlay, aEvent);
        }
    }

    function overlay_OnHover(aEvent) {
        var lOverlay = this;

        // delay is created
        mMouseOverTimeOut = setTimeout(function () {
            if (!mThis.isNothing(mHoverEventHandler)) {
                mHoverEventHandler(lOverlay, aEvent);
            }
        }, mHoverMapDelaySeconds * 1000);
    }

    function overlay_OnHoverOut(aEvent) {
        var lOverlay = this;

        if (!mThis.isNothing(mHoverOutEventHandler)) {
            clearTimeout(mMouseOverTimeOut); // clear timeout or else will always exist
            mMouseOverTimeOut = null; // safety null
            mHoverOutEventHandler(lOverlay, aEvent);
        }
    }

    function circle_OnShapeChanged() {
        var lShape = this;
        if (!mThis.isNothing(mShapeChangeHandler)) {
            mShapeChangeHandler(lShape);
        }
    }

    function polygon_OnInsert(aIndex) {
        var lShape = this.sumoParent;
        if (!mThis.isNothing(mShapeChangeHandler)) {
            mShapeChangeHandler(lShape, aIndex, 'insert');
        }
    }

    function polygon_OnRemove(aIndex) {
        var lShape = this.sumoParent;
        if (!mThis.isNothing(mShapeChangeHandler)) {
            mShapeChangeHandler(lShape, aIndex, 'remove');
        }
    }

    function polygon_OnSet(aIndex) {
        var lShape = this.sumoParent;
        if (!mThis.isNothing(mShapeChangeHandler)) {
            mShapeChangeHandler(lShape, aIndex, 'set');
        }
    }

    function bindMarkerData() {
        var lKey,
            lDataItem,
            lMarker,
            lMarkerImage,
            lZIndex = mZIndexStart,
            lPosition,
            lIcon,           
            lIsClickable = !mThis.isNothing(mClickEventHandler),
            lIsRightClickable = !mThis.isNothing(mRightClickEventHandler),
            lIsDraggable = !mThis.isNothing(mDragEndEventHandler),
            lCursor = 'pointer',
			lCardViewClass = ["10400000", "11400000", "20400000", "21400000"];

        mMarkerCollection = [];

        for (lKey in mDataSource) {
            if (mDataSource.hasOwnProperty(lKey)) {
                lDataItem = mDataSource[lKey];
                if (!mThis.isNothing(lDataItem)) {
                    lMarkerImage = new google.maps.MarkerImage(lDataItem.iconUri);

                    lMarkerImage.anchor = new google.maps.Point(lDataItem.anchor.x, lDataItem.anchor.y);
                    lPosition = new google.maps.LatLng(lDataItem.latitude, lDataItem.longitude);
                    if (!mThis.isNothing(mMarkerImageSize)) {
                        lMarkerImage.scaledSize = mMarkerImageSize;
                    } else if (!isNullOrUndefined(lDataItem.ScaledImageSize)) {
                        lMarkerImage.scaledSize = lDataItem.ScaledImageSize;
                    }
                    lMarker = new google.maps.Marker({
                        'position': lPosition,
                        'clickable': lIsClickable,
                        'rightclickable':lIsRightClickable,
                        'title': lDataItem.hoverHtml,
                        'visible': false,
                        'zIndex': lZIndex++,
                        'map': mMap,
                        'flat': true,
                        'draggable': lIsDraggable,
                        'cursor': lCursor,
                        'icon': lMarkerImage,
                        'label': lDataItem.label
                    });

                    if (lDataItem.bindMarkers) {
                        for (var mKey in lDataItem.bindMarkers) {
                            if (lDataItem.bindMarkers.hasOwnProperty(mKey)) {
                                lIcon = {
                                    'path': google.maps.SymbolPath.CIRCLE,
                                    'fillOpacity': 1,
                                    'fillColor': lDataItem.bindMarkers[mKey].color,
                                    'strokeOpacity': 1,
                                    'strokeWeight': 0,
                                    'strokeColor': 'white',
                                    'scale': 7,
                                    'scaledSize': new google.maps.Size(0, 0),
                                    'anchor': new google.maps.Point(lDataItem.bindMarkers[mKey].anchorlat, lDataItem.bindMarkers[mKey].anchorlng)
                                };
                               
                                var mCurrentBindMarker = new google.maps.Marker({
                                    'position': lPosition,
                                    'zIndex': lZIndex,
                                    'anchor': new google.maps.Point(0, 0),
                                    'icon': lIcon,
                                    'label': {
                                        'color': '#fff',
                                        'fontSize': '8px',
                                        'fontWeight': '600',
                                        'align': 'center',
                                        'text': lDataItem.bindMarkers[mKey].text
                                    }
                                });

                                mCurrentBindMarker.bindTo('center', lMarker, 'position');
                                mCurrentBindMarker.bindTo('map', lMarker, 'map');
                            }
                        }
                    }
                    if ($.inArray(lDataItem.cardViewClass, lCardViewClass) > -1) {
                        lMarker.zIndex += 100;
                    }
                    lMarker.sumoData = lDataItem.data;
                    lMarker.sumoOverlayOnClickListener = null;
                    lMarker.sumoOverlayOnRightClickListener =null;
                    lMarker.OverlayOnHoverListener = null;
                    lMarker.OverlayOnHoverOutListener = null;
                    lMarker.identity = lDataItem[mIdentityProperty];
                    if (!mThis.isNothing(mDragEndEventHandler)) {
                        lMarker.sumoOverlayOnDragEndListener = google.maps.event.addListener(lMarker, 'dragend', overlay_OnDragEnd);
                    }
                    if (!mThis.isNothing(mClickEventHandler)) {
                        lMarker.sumoOverlayOnClickListener = google.maps.event.addListener(lMarker, 'click', overlay_OnClick);
                    }
                    if (!mThis.isNothing(mRightClickEventHandler)) {
                        lMarker.sumoOverlayOnRightClickListener = google.maps.event.addListener(lMarker, 'rightclick', overlay_OnRightClick);
                    }
                    if (!mThis.isNothing(mHoverEventHandler)) {
                        lMarker.OverlayOnHoverListener = google.maps.event.addListener(lMarker, 'mouseover', overlay_OnHover);
                    }
                    if (!mThis.isNothing(mHoverOutEventHandler)) {
                        lMarker.OverlayOnHoverOutListener = google.maps.event.addListener(lMarker, 'mouseout', overlay_OnHoverOut);
                    }

                    // replaced hover label with "title" above because google maps is a piece of shit and wicked slow to boot
                    // doHover, hoverHtml, hoverCssClass, hoverVerticalOffset, hoverHorizontalOffset
                    //                if (!mThis.isNothing(lDataItem.doHover) && lDataItem.doHover === true) {
                    //                    lMarker.hoverLabel = new sumo.maps.Label({
                    //                        'position': lPosition,
                    //                        'text': lDataItem.hoverHtml,
                    //                        'cssClass': lDataItem.hoverCssClass,
                    //                        'clickable': false,
                    //                        'visible': false,
                    //                        'horizontalOffset': lDataItem.hoverHorizontalOffset,
                    //                        'verticalOffset': lDataItem.hoverVerticalOffset,
                    //                        'zIndex': cMaxZIndex,
                    //                        'map': mMap
                    //                    });
                    //                    lMarker.sumoOverlayOnMouseEnter = google.maps.event.addListener(lMarker, 'mouseover', overlay_OnMouseEnter);
                    //                    lMarker.sumoOverlayOnMouseExit = google.maps.event.addListener(lMarker, 'mouseout', overlay_OnMouseExit);
                    //                }

                    mOverlays.push(lMarker);
                    if (!isNullOrUndefined(lMarker.icon)) {
                        mMarkerCollection.push(lMarker.icon.url);
                    } else {
                        mMarkerCollection.push(lMarker);
                    }
                   
                }
            }
        }
    }

    //'geometry': dataItem: {id, type: ('circle'|'polygonal'), centerLatitude, centerLongitude, radius (in meters), vertices: [Point:{latitude, longitude}], 
    //            hoverHtml, fillColor, fillOpacity, strokeColor, strokeOpacity, strokeWeight, data}
    function bindGeometryData() {
        var lKey,
            lDataItem,
            lVertexKey,
            lVertex,
            lVertices,
            lSWLat,
            lSWLng,
            lNELat,
            lNELng,
            lCenterLatitude,
            lCenterLongitude,
            lVertexCount,
            lIsClickable = !mThis.isNothing(mClickEventHandler),
            lIsRightClickable = !mThis.isNothing(mRightClickEventHandler),
            lPath,
            lShape;

        for (lKey in mDataSource) {
            if (mDataSource.hasOwnProperty(lKey)) {
                lDataItem = mDataSource[lKey];

                if (lDataItem.type === 'circle') {
                    lShape = new google.maps.Circle({
                        'center': new google.maps.LatLng(lDataItem.centerLatitude, lDataItem.centerLongitude),
                        'radius': lDataItem.radius,
                        'map': mMap,
                        'editable': !mThis.isNothing(lDataItem.isEditable) && lDataItem.isEditable,
                        'strokeColor': lDataItem.strokeColor,
                        'strokeOpacity': lDataItem.strokeOpacity,
                        'strokeWeight': lDataItem.strokeWeight,
                        'visible': false,
                        'fillColor': lDataItem.fillColor,
                        'fillOpacity': lDataItem.fillOpacity,
                        'clickable': lIsClickable,
                        'rightclickable':lIsRightClickable
                    });
                    lShape.sumoId = lDataItem.id;
                    lShape.sumoData = lDataItem.data;
                    lShape.sumoCircleRadiusChanged = null;
                    lShape.sumoCircleCenterChanged = null;
                    if (!mThis.isNothing(mShapeChangeHandler)) {
                        lShape.sumoCircleRadiusChanged = google.maps.event.addListener(lShape, 'radius_changed', circle_OnShapeChanged);
                        lShape.sumoCircleCenterChanged = google.maps.event.addListener(lShape, 'center_changed', circle_OnShapeChanged);
                    }
                    lShape.sumoOverlayOnClickListener = null;
                    lShape.sumoOverlayOnRightClickListener = null;
                    if (!mThis.isNothing(mClickEventHandler)) {
                        lShape.sumoOverlayOnClickListener = google.maps.event.addListener(lShape, 'click', overlay_OnClick);
                    }
                    if (!mThis.isNothing(mRightClickEventHandler)) {
                        lShape.sumoOverlayOnRightClickListener = google.maps.event.addListener(lShape, 'rightclick', overlay_OnRightClick);
                    }
                    mOverlays.push(lShape);
                } else {
                    lVertices = [];
                    lNELat = null;
                    lNELng = null;
                    lSWLat = null;
                    lSWLng = null;
                    lCenterLatitude = 0;
                    lCenterLongitude = 0;
                    lVertexCount = 0;
                    for (lVertexKey in lDataItem.vertices) {
                        if (lDataItem.vertices.hasOwnProperty(lVertexKey)) {
                            lVertex = lDataItem.vertices[lVertexKey];
                            lVertices.push(new google.maps.LatLng(lVertex.latitude, lVertex.longitude));
                            lCenterLatitude += lVertex.latitude;
                            lCenterLongitude += lVertex.longitude;
                            lVertexCount++;
                            if (lNELat === null) {
                                lNELat = lVertex.latitude;
                                lNELng = lVertex.longitude;
                                lSWLat = lVertex.latitude;
                                lSWLng = lVertex.longitude;
                            }
                            if (lVertex.latitude > lNELat) {
                                lNELat = lVertex.latitude;
                            }
                            if (lVertex.longitude > lNELng) {
                                lNELng = lVertex.longitude;
                            }
                            if (lVertex.latitude < lSWLat) {
                                lSWLat = lVertex.latitude;
                            }
                            if (lVertex.longitude < lSWLng) {
                                lSWLng = lVertex.longitude;
                            }
                        }
                    }
                    lCenterLatitude /= lVertexCount;
                    lCenterLongitude /= lVertexCount;

                    lShape = new google.maps.Polygon({
                        //'center': new google.maps.LatLng(lDataItem.centerLatitude, lDataItem.centerLongitude),
                        //'radius': lDataItem.radius,
                        'map': mMap,
                        'paths': lVertices,
                        'editable': !mThis.isNothing(lDataItem.isEditable) && lDataItem.isEditable,
                        'strokeColor': lDataItem.strokeColor,
                        'strokeOpacity': lDataItem.strokeOpacity,
                        'strokeWeight': lDataItem.strokeWeight,
                        'visible': false,
                        'fillColor': lDataItem.fillColor,
                        'fillOpacity': lDataItem.fillOpacity,
                        'clickable': lIsClickable,
                        'draggable': false
                    });
                    lShape.getCenter = function () { return new google.maps.LatLng(lCenterLatitude, lCenterLongitude); };

                    lShape.sumoBounds = new google.maps.LatLngBounds(new google.maps.LatLng(lSWLat, lSWLng), new google.maps.LatLng(lNELat, lNELng));
                    lShape.getBounds = function () { return this.sumoBounds; };
                    lShape.sumoId = lDataItem.id;
                    lShape.sumoData = lDataItem.data;
                    lShape.sumoPolygonOnInsert = null;
                    lShape.sumoPolygonOnRemove = null;
                    lShape.sumoPolygonOnSet = null;
                    lPath = lShape.getPath();
                    if (!mThis.isNothing(lPath)) {
                        lPath.sumoParent = lShape;
                        if (!mThis.isNothing(mShapeChangeHandler)) {
                            lShape.sumoPolygonOnInsert = google.maps.event.addListener(lPath, 'insert_at', polygon_OnInsert);
                            lShape.sumoPolygonOnRemove = google.maps.event.addListener(lPath, 'remove_at', polygon_OnRemove);
                            lShape.sumoPolygonOnSet = google.maps.event.addListener(lPath, 'set_at', polygon_OnSet);
                        }
                        lShape.sumoOverlayOnClickListener = null;
                        lShape.sumoOverlayOnRightClickListener = null;
                        if (!mThis.isNothing(mClickEventHandler)) {
                            lShape.sumoOverlayOnClickListener = google.maps.event.addListener(lShape, 'click', overlay_OnClick);
                        }
                        if (!mThis.isNothing(mRightClickEventHandler)) {
                            lShape.sumoOverlayOnRightClickListener = google.maps.event.addListener(lShape, 'rightclick', overlay_RightClick);
                        }
                        mOverlays.push(lShape);
                    }
                }
            }
        }
    }

    function bindLineSegementData() {
        var lKey,
            lDataItem,
            lPolyline,
            lZIndex = mZIndexStart,
            lStrokeWidth = 2,
            lPositionStart,
            lPositionEnd ;

        for (lKey in mDataSource) {
            if (mDataSource.hasOwnProperty(lKey)) {
                lDataItem = mDataSource[lKey];
                
                if (!isNullOrUndefined(lDataItem.strokeWidth)) {
                    lStrokeWidth = lDataItem.strokeWidth;
                }

                lPositionStart = new google.maps.LatLng(lDataItem.begin.latitude, lDataItem.begin.longitude);
                lPositionEnd = new google.maps.LatLng(lDataItem.end.latitude, lDataItem.end.longitude);
                lPolyline = new google.maps.Polyline({
                    'path': [lPositionStart, lPositionEnd],
                    'clickable': true,
                    'visible': false,
                    'zIndex': lZIndex++,
                    'map': mMap,
                    'editable': false,
                    'strokeWeight': lStrokeWidth,
                    'strokeColor': lDataItem.StrokeColor
                });
                lPolyline.sumoData = lDataItem.data;
                lPolyline.sumoOverlayOnClickListener = null;

                mOverlays.push(lPolyline);
            }
        }
    }

    function bindLabelData() {
        var lKey,
            lDataItem,
            lLabel,
            lZIndex = mZIndexStart;

        for (lKey in mDataSource) {
            if (mDataSource.hasOwnProperty(lKey)) {
                lDataItem = mDataSource[lKey];

                lLabel = new sumo.maps.Label({
                    'position': new google.maps.LatLng(lDataItem.latitude, lDataItem.longitude),
                    'text': lDataItem.text,
                    'cssClass': lDataItem.cssClass,
                    'clickable': true,
                    'visible': false,
                    'horizontalOffset': lDataItem.horizontalOffset,
                    'verticalOffset': lDataItem.verticalOffset,
                    'zIndex': lZIndex++,
                    'map': mMap
                });
                lLabel.sumoData = lDataItem.data;
                lLabel.sumoOverlayOnClickListener = null;
                mOverlays.push(lLabel);
            }
        }
    }

    function dataBind() {
        setVisibility(false); // hide them first is WAY faster
        clearOverlays(); // destroy the markers/mvcobjects

        switch (mRenderType) {
            case 'marker':
                bindMarkerData();
                break;
            case 'geometry':
                bindGeometryData();
                break;
            case 'linesegment':
                bindLineSegementData();
                break;
            case 'label':
                bindLabelData();
                break;
        }

        setVisibility(mIsVisible);

        mIsDirty = false;

        mThis.trigger('databind');
    }

    this.getShape = function (aShapeId) {
        if (mRenderType !== 'geometry') {
            throw ('Layer.getShape() is only valid for layers of render type \'geometry\'. This layer has a render type of: ' + mRenderType);
        }
        var lIndex,
            lLength = mOverlays.length,
            lResult = null;
        for (lIndex = 0; lIndex < lLength; lIndex++) {
            if (mOverlays[lIndex].sumoId === aShapeId) {
                lResult = mOverlays[lIndex];
                break;
            }
        }
        return lResult;
    };

    this.setDataSource = function (aDataSource) {
        mDataSource = aDataSource;
        mIsDirty = true;
        if (mIsVisible) {
            dataBind();
        }
    };


    this.getDataSource = function () {
        return mDataSource;
    };


    this.overlayIsVisible = function (aIndex) {
        var lResult = false;
        if (aIndex < mOverlays.length && aIndex >= 0) {
            lResult = mOverlays[aIndex].getVisible();
        }
        return lResult;
    };
    
    this.getMarkerOverlay = function (aIndex) {
        var lResult = null;
        if (aIndex < mMarkerCollection.length && aIndex >= 0) {
            lResult = mMarkerCollection[aIndex];
        }
        return lResult;
    };

    this.fixOverLay = function () {
        var aIndex = 0;
        for (aIndex = 0; aIndex < mOverlays.length; aIndex++) {
            mOverlays[aIndex].icon.url = mMarkerCollection[aIndex];
        }
    }

    this.showOverlay = function (aIndex) {
        var lResult = null;
        if (aIndex < mOverlays.length && aIndex >= 0) {
            lResult = mOverlays[aIndex];
            lResult.setVisible(true);
        }
        return lResult;
    };

    this.hideOverlay = function (aIndex) {
        var lResult = null;
        if (aIndex < mOverlays.length && aIndex >= 0) {
            lResult = mOverlays[aIndex];
            lResult.setVisible(false);
        }
        return lResult;
    };

    this.show = function () {
        if (!mIsVisible) {
            mIsVisible = true;
            if (mIsDirty) {
                dataBind();
            }
            setVisibility(mIsVisible);
        }
    };

    this.hide = function () {
        //if (mIsVisible) {
        mIsVisible = false;
        setVisibility(mIsVisible);
        //}
    };

    this.isVisible = function (aValue) {
        if (!this.isNothing(aValue)) {
            mIsVisible = aValue;
            setVisibility(mIsVisible);
        }
        return mIsVisible;
    };

    this.fitBounds = function (aMapBounds) {
        var lMapBounds = aMapBounds,
            lIndex,
            lLength = mOverlays.length,
            lOverlayBounds,
            lOverlay;

        if (mRenderType !== 'linesegment') {
            for (lIndex = 0; lIndex < lLength; lIndex++) {
                lOverlay = mOverlays[lIndex];
                // during playback, some display objects may be visible=false
                if (lOverlay.getVisible()) {
                    if (mRenderType === 'geometry') {
                        lOverlayBounds = lOverlay.getBounds();
                        lMapBounds.extend(lOverlayBounds.getNorthEast());
                        lMapBounds.extend(lOverlayBounds.getSouthWest());
                    } else {
                        lMapBounds.extend(lOverlay.getPosition());
                    }
                }
            }
        }
        return lMapBounds;
    };

    this.panToOverlay = function (aIndex) {
        var lMapBounds,
            lPosition;
        if (aIndex < mOverlays.length && aIndex > -1) {
            lMapBounds = mMap.getBounds();
            if (mRenderType === 'geometry') {
                lPosition = mOverlays[aIndex].getCenter();
            } else {
                lPosition = mOverlays[aIndex].getPosition();
            }

            if (!lMapBounds.contains(lPosition)) {
                mMap.panTo(lPosition);
            }
        }
    };

    this.overlays = function () {
        return mOverlays;
    };

    this.dispose = function () {
        clearOverlays();

        mOverlays = null;
        mMap = null;
        mDataSource = null;

        mClickEventHandler = null;
        mRightClickEventHandler = null;
        sumo.maps.Layer.prototype.dispose.call(this);
    };
};
sumo.maps.Layer.prototype = new sumo.Class();
sumo.maps.Layer.prototype.constructor = sumo.maps.Layer;
sumo.maps.Layer.prototype.baseClass = sumo.Class;